import React from 'react';
import ListItems from './ListItems';  // внутренний компонент с  CSS импортом

const PerformanceApp = () => {
  return (
    <div>
      <h1>Performance App</h1>
      <ListItems />
     
    </div>
  );
};

export default PerformanceApp;
